'use client';

import { createContext, useContext, type PropsWithChildren } from 'react';

const PageNameContext = createContext<string | undefined>(undefined);

export const usePageName = () => useContext(PageNameContext);

export type PageNameProviderProps = { pageName?: string };

export default function PageNameProvider({ pageName, children }: PropsWithChildren<PageNameProviderProps>) {
	return <PageNameContext.Provider value={pageName}>{children}</PageNameContext.Provider>;
}
